import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

import BestRideShareLawyersWrapper from "@components/layouts/bestridesharelawyersWrapper";
export default function BestRideShareLawyersHome(): ReactElement {
    return (
        <BestRideShareLawyersWrapper>
            <TermsAndConditions
                category="Ride Share"
                domain="BestRideShareLawyers.com"
            />
        </BestRideShareLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
